var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormControl as MuiFormControl, FormLabel as MuiFormLabel, RadioGroup as MuiRadioGroup } from '@mui/material';
import React, { useId } from 'react';
import { getAttributes, ThemeUtils } from '../../../utils';
import { RadioButton } from '../../atoms/radio-button';
import { isColorButton, RadioButtonDesignStyles } from '../../atoms/radio-button/types';
import { ContainerPaddings } from '../../templates/container';
import { InputMessages } from '../common/input-messages';
import { RadioGroupOrientations } from './types';
var RG = function (_a) {
    var props = __rest(_a, []);
    var className = props.className, title = props.title, id = props.id, name = props.name, _b = props.value, value = _b === void 0 ? '' : _b, required = props.required, _c = props.radioButtons, radioButtons = _c === void 0 ? [] : _c, helperText = props.helperText, successHint = props.successHint, errorHint = props.errorHint, rowProp = props.row, _d = props.wrap, wrapProp = _d === void 0 ? true : _d, designStyle = props.designStyle, ariaLabel = props["aria-label"], onChange = props.onChange, rest = __rest(props, ["className", "title", "id", "name", "value", "required", "radioButtons", "helperText", "successHint", "errorHint", "row", "wrap", "designStyle", 'aria-label', "onChange"]);
    var messageHintId = useId();
    var formControlProps = {
        className: 'custom-radio-group',
        'aria-label': ariaLabel,
        id: id,
        role: 'radiogroup',
        error: Boolean(errorHint)
    };
    var radioGroupProps = __assign({ 'aria-describedby': messageHintId, name: name, value: value, role: undefined, row: rowProp === RadioGroupOrientations.Horizontal, onChange: onChange, className: [
            className,
            rowProp === RadioGroupOrientations.Horizontal && !wrapProp && 'no-wrap',
            designStyle === RadioButtonDesignStyles.Standard && 'standard',
            designStyle === RadioButtonDesignStyles.Rounded && 'rounded'
        ]
            .filter(Boolean)
            .join(' ') }, getAttributes(rest));
    var padding = ThemeUtils.getResponsiveProp([
        { t: ContainerPaddings.Size_3 }
    ]);
    var inputMessagesProps = __assign({ id: messageHintId, helperText: helperText, successHint: successHint, errorHint: errorHint }, ((errorHint || successHint || errorHint) && { padding: padding }));
    return (React.createElement(MuiFormControl, __assign({}, formControlProps),
        title && (React.createElement(MuiFormLabel, { className: "custom-form-label", component: "p", required: required }, title)),
        React.createElement(MuiRadioGroup, __assign({}, radioGroupProps), radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.map(function (button, index) { return (React.createElement(RadioButton, __assign({ label: button.label, onMouseOver: button.onMouseOver, onMouseLeave: button.onMouseLeave, onFocus: button.onFocus, onBlur: button.onBlur, key: "radio-button-".concat(index), size: button.size, designStyle: button.designStyle, onChange: button.onChange, color: isColorButton(button) ? button.color : undefined, checked: button.checked, disabled: button.disabled, readOnly: button.readOnly, error: button.error, value: button.value, state: button.state, icon: button.icon, checkedIcon: button.checkedIcon, width: button.width }, getAttributes(button)))); })),
        React.createElement(InputMessages, __assign({}, inputMessagesProps))));
};
export { RG as RadioGroup };
